const boostApiConfig = {
  mode: 'production',
  api: {
    filterUrl: 'https://services.mybcapps.com/bc-sf-filter/filter',
    searchUrl: 'https://services.mybcapps.com/bc-sf-filter/search',
    recommendUrl: 'https://services.mybcapps.com/discovery/recommend',
    suggestionUrl: 'https://services.mybcapps.com/bc-sf-filter/search/suggest',
    productsUrl: 'https://services.mybcapps.com/bc-sf-filter/search/products',
    cdn: 'https://boost-cdn-prod.bc-solutions.net',
    analyticsUrl: 'https://lambda.mybcapps.com/e',
  },
  shop: {
    name: 'NY AND COMPANY',
    url: 'https://sg-nyandco-dev.myshopify.com',
    domain: 'sg-nyandco.myshopify.com',
    currency: 'USD',
    money_format: '<span class="money">&#36;{{amount}}</span>',
    money_format_with_currency: '<span class="money">&#36;{{amount}}</span',
  },
  allowedFilters: ['pf_opt_size', 'pf_opt_color', 'pf_p_price'],
}

function isValidFacet(filter) {
    const facetName = filter ? filter.toLowerCase() : '';
    return (
    facetName &&
    (facetName === 'price' ||
        facetName.startsWith('pf_') ||
        facetName.includes('color_family'))
    );
}

async function getSearchResults(params) {
  const shopifyStoreDomain = params.shopifyStoreDomain || boostApiConfig.shop.domain;
  const limit = params?.limit ? params.limit : 12;
  const page = params?.page;
  let apiUrl =
    boostApiConfig.api.searchUrl +
    '?t=' +
    Date.now() +
    '&shop=' +
    shopifyStoreDomain +
    '&q=' +
    params?.q +
    '&page=' +
    (page ? page : 1) +
    '&limit=' +
    limit +
    '&sort=' +
    (params?.sortBy ? params.sortBy : 'relevance') +
    '&event_type=init&locale=en&build_filter_tree=true&zero_options=false&pg=search_page&product_available=true&variant_available=true';
  if (params?.filters && Object.keys(params?.filters)?.length) {
    let filterString = '';
    Object.keys(params?.filters)?.forEach((key) => {
      const filterValues = params?.filters[key];
      if (filterValues && filterValues.length) {
        filterValues?.forEach((val) => {
          filterString && (filterString += '&');
          if (key.includes('price')) {
            val = val.replace('-', ':').replace('*', '');
          }
          filterString += key + '[]=' + val;
        });
      }
    });
    apiUrl += '&' + filterString;
  }
  console.log('apiUrl :: ', apiUrl);
  const searchResult = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (searchResult.ok) {
    const boostSearchResultJson = await searchResult.json();
    boostSearchResultJson['page'] = page ? page : 1;
    const total_products = parseInt(boostSearchResultJson?.total_product || 0);
    console.log('total_products :: ', total_products);
    boostSearchResultJson['nbPages'] =
      total_products % limit === 0
        ? Math.floor(total_products / limit)
        : Math.floor(total_products / limit) + 1;
    // console.log('boostSearchResultJson :: ', boostSearchResultJson);
    return boostSearchResultJson;
  }
  return {};
}

async function getCollectionResults(params) {
  console.log(params);
  // https://services.mybcapps.com/bc-sf-filter/filter?t=1709828602287&_=pf&shop=sg-lordandtaylor.myshopify.com&page=1&limit=28&sort=relevance&locale=en&event_type=collection&build_filter_tree=true&sid=b7678532-4eda-42aa-9ab7-238afa9501db&pg=collection_page&zero_options=false&product_available=true&variant_available=true&collection_scope=261106499760

  const shopifyStoreDomain = params.shopifyStoreDomain || boostApiConfig.shop.domain;
  const limit = params?.limit ? params.limit : 12;
  const page = params?.page;
  let apiUrl =
    boostApiConfig.api.filterUrl +
    '?t=' +
    Date.now() +
    '&shop=' +
    shopifyStoreDomain +
    '&collection_scope=' +
    params?.collectionId +
    '&page=' +
    (page ? page : 1) +
    '&limit=' +
    limit +
    '&sort=' +
    (params?.sortBy ? params.sortBy : 'relevance') +
    '&event_type=collection&locale=en&build_filter_tree=true&pg=collection_page&zero_options=false&product_available=true&variant_available=true';
  if (params?.filters && Object.keys(params?.filters)?.length) {
    let filterString = '';
    Object.keys(params?.filters)?.forEach((key) => {
      const filterValues = params?.filters[key];
      if (filterValues && filterValues.length) {
        filterValues?.forEach((val) => {
          filterString && (filterString += '&');
          if (key.includes('price')) {
            val = val.replace('-', ':').replace('*', '');
          }
          filterString += key + '[]=' + val;
        });
      }
    });
    apiUrl += '&' + filterString;
  }
  console.log('apiUrl :: ', apiUrl);
  const filterResult = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (filterResult.ok) {
    const boostFilterResultJson = await filterResult.json();
    boostFilterResultJson['page'] = page ? page : 1;
    boostFilterResultJson['collectionId'] = params?.collectionId;
    const total_products = parseInt(boostFilterResultJson?.total_product || 0);
    console.log('total_products :: ', total_products);
    boostFilterResultJson['nbPages'] =
      total_products % limit === 0
        ? Math.floor(total_products / limit)
        : Math.floor(total_products / limit) + 1;
    // console.log('boostFilterResultJson :: ', boostFilterResultJson);
    return boostFilterResultJson;
  }
}
